import { fetchAuth } from "../../../shared/api/ApiService"
import { IWorkTg } from "../model/types"

interface IWorkTgResponse {
    id: string;
    name: string;
}

const mapWorkTg = (workTg: IWorkTgResponse): IWorkTg => ({
    id: Number(workTg.id),
    name: workTg.name,
})

class WorkTgService {
    
    async getAll(): Promise<IWorkTg[]> {
        const res = await fetchAuth(process.env.REACT_APP_SERVER_URL_ADMIN + '/api/v1/work_tgs')
        const data = await res.json() as {workTgs: IWorkTgResponse[]}

        return data.workTgs.map(mapWorkTg)
    }

    async create(name: string): Promise<IWorkTg> {
        const res = await fetchAuth(process.env.REACT_APP_SERVER_URL_ADMIN + '/api/v1/work_tgs', {
            method: 'POST',
            body: JSON.stringify({name}),
        })
        const data = await res.json() as {workTg: IWorkTgResponse}

        return mapWorkTg(data.workTg)
    }

    async update(tgId: number, name: string): Promise<IWorkTg> {
        const res = await fetchAuth(process.env.REACT_APP_SERVER_URL_ADMIN + `/api/v1/work_tgs/${tgId}`, {
            method: 'POST',
            body: JSON.stringify({tgId, name}),
        })
        const data = await res.json() as {workTg: IWorkTgResponse}

        return mapWorkTg(data.workTg)
    }

    async delete(tgId: number, newWorkTg: number): Promise<void> {
        await fetchAuth(process.env.REACT_APP_SERVER_URL_ADMIN + `/api/v1/work_tgs/${tgId}/delete`, {
            method: 'POST',
            body: JSON.stringify({newWorkTg}),
        })
    }

    async getAssignedToUser(userId: number): Promise<IWorkTg[]> {
        const res = await fetchAuth(process.env.REACT_APP_SERVER_URL_ADMIN + `/api/v1/work_tgs/users/${userId}`)
        const data = await res.json() as {workTgs: IWorkTgResponse[]}

        return data.workTgs.map(mapWorkTg)
    }

    async addToUser(userId: number, tgId: number): Promise<void> {
        await fetchAuth(process.env.REACT_APP_SERVER_URL_ADMIN + `/api/v1/work_tgs/users/${userId}/add`, {
            method: 'POST',
            body: JSON.stringify({userId, tgId}),
        })
    }

    async removeFromUser(userId: number, tgId: number): Promise<void> {
        await fetchAuth(process.env.REACT_APP_SERVER_URL_ADMIN + `/api/v1/work_tgs/users/${userId}/delete`, {
            method: 'POST',
            body: JSON.stringify({userId, tgId}),
        })
    }

    async moveUser(userId: number, newTgId: number): Promise<void> {
        await fetchAuth(process.env.REACT_APP_SERVER_URL_ADMIN + `/api/v1/work_tgs/users/${userId}/move`, {
            method: 'POST',
            body: JSON.stringify({new_tg_id: newTgId}),
        })
    }
}

export const workTgService = new WorkTgService()
